import SharesLiquidityAnswer from 'pages/lend/components/LandaFinancingFAQ/components/SharesLiquidityAnswer';
import React from 'react';
import { DebtType } from 'types/debt-types';

export const FAQ = [
  {
    question: 'What am I investing in?',
    answer:
      'When you buy shares, you are investing in the fund, Landa Financing LLC. The funds raised are used' +
      'to provide first mortgage loans to rental properties. Lend collects monthly interest from its mortgage' +
      'portfolio. The net proceeds from these interest payments are then distributed as monthly dividend to shareholders ' +
      'Lend enables investors to enjoy the profits from interest rates that have historically been only available to banks. ',
  },
  {
    question: 'How liquid are my shares?',
    answerComponent: (debt: DebtType) => <SharesLiquidityAnswer debt={debt} />,
  },
  {
    question: 'How am I taxed?',
    answer:
      'Lend is structured as a mortgage REIT to optimize tax efficiency. As long as Lend continues to qualify ' +
      'as a REIT, there is no income tax at the fund level. Investors will receive a yearly 1099-DIV form' +
      'by January 31st of each calendar year.',
  },
  {
    question: 'Can I reinvest my dividends?',
    answer: 'Dividend re-investing will be available soon. Stay tuned.',
  },
  {
    question: 'What happens when the interest rate changes?',
    answer:
      'Since Lend offers adjustable-rate mortgages, interest rate changes will result in changes to the ' +
      'interest payments collected by Lend, which will result in changes to the dividend payments paid to investors.',
  },
  {
    question: 'Will Lend fund properties from the Landa app or external ones?',
    answer:
      'The funds raised will be primarily used to provide first mortgage loans to single-family rental' +
      ' properties offered within the Landa app, but may also include rental properties not offered on' +
      ' the Landa platform.',
  },
];
